import http from '@/providers/http'

// 业务资金账户资产信息 
export const apiGetFinanceAccountInfo = (params = {}) => {
    return http.get('/finance-center/member/account/info', params)
}
// 获取会员绑定的提现账户
export const apiGetFinanceWithdrawAccount = (params = {}) => {
    return http.get('/finance-center/member/withdraw/account/binds', params)
}
// 申请秒杀余额提现
export const apiFinanceMembernNewSpikeWithdraw = (params = {}) => {
    return http.post('/finance-center/member/withdraw/record/newSpikeWithdraw', params)
}
// 余额收支明细列表
export const apiFinanceMembernAccountRecordList = (params = {}) => {
    return http.post('/finance-center/member/account/record/list', params)
}
// 余额收支明细详情
export const apiFinanceMembernAccountRecordDetail = (params = {}) => {
    return http.post('/finance-center/member/account/record/detail', params)
}
// 提现明细详情
export const apiFinanceMembernWithdrawRecordDetail = (params = {}) => {
    return http.get('/finance-center/member/withdraw/record/detail', params)
}

